import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, Phone, Instagram, Star } from 'lucide-react';
import { Button } from './ui/Button';
interface HostCardProps {
  name: string;
  title: string;
  image: string;
  specialties: string[];
  bio: string;
  rating: number;
  bookings: number;
  instagram?: string;
  phone: string;
  index: number;
}
export function HostCard({
  name,
  title,
  image,
  specialties,
  bio,
  rating,
  bookings,
  instagram,
  phone,
  index
}: HostCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    delay: index * 0.1,
    duration: 0.5
  }} className="group relative bg-gradient-to-br from-[#1A2228] to-[#0F161B] border border-white/10 rounded-2xl overflow-hidden hover:border-[#DDA247]/50 transition-all duration-300 hover:shadow-[0_0_40px_rgba(221,162,71,0.15)]" data-id="element-388">
      {/* Image Section */}
      <div className="relative h-80 overflow-hidden" data-id="element-389">
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B1014] via-transparent to-transparent z-10" data-id="element-390" />
        <img src={image} alt={name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-391" />

        {/* Stats Overlay */}
        <div className="absolute top-4 right-4 z-20 flex gap-2" data-id="element-392">
          <div className="bg-[#0B1014]/90 backdrop-blur-sm px-3 py-1.5 rounded-full border border-white/10 flex items-center gap-1.5" data-id="element-393">
            <Star className="w-3.5 h-3.5 text-[#DDA247] fill-[#DDA247]" data-id="element-394" />
            <span className="text-xs font-bold text-white" data-id="element-395">{rating}</span>
          </div>
          <div className="bg-[#0B1014]/90 backdrop-blur-sm px-3 py-1.5 rounded-full border border-white/10" data-id="element-396">
            <span className="text-xs font-bold text-white" data-id="element-397">
              {bookings}+ bookings
            </span>
          </div>
        </div>

        {/* Name Overlay */}
        <div className="absolute bottom-0 left-0 right-0 p-6 z-20" data-id="element-398">
          <h3 className="text-2xl font-bold text-white mb-1" data-id="element-399">{name}</h3>
          <p className="text-sm text-[#DDA247] uppercase tracking-widest font-medium" data-id="element-400">
            {title}
          </p>
        </div>
      </div>

      {/* Content Section */}
      <div className="p-6 space-y-6" data-id="element-401">
        {/* Specialties */}
        <div data-id="element-402">
          <p className="text-xs text-gray-500 uppercase tracking-widest mb-3 font-medium" data-id="element-403">
            Specialties
          </p>
          <div className="flex flex-wrap gap-2" data-id="element-404">
            {specialties.map((specialty, idx) => <span key={idx} className="px-3 py-1 bg-[#DDA247]/10 text-[#DDA247] text-xs font-medium rounded-full border border-[#DDA247]/20" data-id="element-405">
                {specialty}
              </span>)}
          </div>
        </div>

        {/* Bio */}
        <p className="text-sm text-gray-400 leading-relaxed" data-id="element-406">{bio}</p>

        {/* Contact Actions */}
        <div className="flex gap-3 pt-4 border-t border-white/5" data-id="element-407">
          <Button variant="primary" size="sm" className="flex-1 group/btn" onClick={() => window.location.href = `tel:${phone}`} data-id="element-408">
            <Phone className="w-4 h-4 mr-2 group-hover/btn:rotate-12 transition-transform" data-id="element-409" />
            Call
          </Button>
          <Button variant="outline" size="sm" className="flex-1 group/btn" onClick={() => window.location.href = `sms:${phone}`} data-id="element-410">
            <MessageCircle className="w-4 h-4 mr-2 group-hover/btn:scale-110 transition-transform" data-id="element-411" />
            Text
          </Button>
          {instagram && <motion.button whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} onClick={() => window.open(instagram, '_blank')} className="w-10 h-10 bg-[#DDA247]/10 rounded-lg flex items-center justify-center hover:bg-[#DDA247] hover:text-[#0B1014] text-[#DDA247] transition-all" data-id="element-412">
              <Instagram className="w-4 h-4" data-id="element-413" />
            </motion.button>}
        </div>
      </div>
    </motion.div>;
}